module.exports = __webpack_public_path__ + "static/media/ProductRecommendationDesktop.88947708.png";